"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAmountInWords = exports.formatCurrencyInWords = exports.formatCentsInWords = exports.toWords = void 0;
const number_to_words_1 = __importDefault(require("number-to-words"));
const toWords = (number) => {
    return number_to_words_1.default.toWords(number);
};
exports.toWords = toWords;
const formatCentsInWords = (currency) => {
    switch (currency.toUpperCase()) {
        case 'GBP':
            return 'pence';
        default:
            return 'cents';
    }
};
exports.formatCentsInWords = formatCentsInWords;
const formatCurrencyInWords = (currency) => {
    switch (currency.toUpperCase()) {
        case 'EUR':
            return 'euros';
        case 'GBP':
            return 'pounds';
        default:
            return 'dollars';
    }
};
exports.formatCurrencyInWords = formatCurrencyInWords;
const formatAmountInWords = (amount, currency) => {
    let dollars = Math.floor(amount);
    let cents = Math.round((amount - dollars) * 100);
    if (cents >= 100) {
        dollars += Math.floor(cents / 100);
        cents %= 100;
    }
    const amountText = (0, exports.toWords)(dollars);
    const currencyText = (0, exports.formatCurrencyInWords)(currency);
    const centsText = (0, exports.formatCentsInWords)(currency);
    if (cents > 0) {
        const centsAmountText = (0, exports.toWords)(cents);
        return `${dollars > 0 ? `${amountText} ${currencyText} and ` : ''}${centsAmountText} ${centsText}`;
    }
    else {
        return `${amountText} ${currencyText}`;
    }
};
exports.formatAmountInWords = formatAmountInWords;
